import React from 'react';
import { restaurants } from './RestaurantData';

interface RestaurantGalleryModalProps {
  onClose: () => void;
  onBack: () => void;
}

const RestaurantGalleryModal: React.FC<RestaurantGalleryModalProps> = ({ onClose, onBack }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content restaurant-gallery-modal" onClick={(e) => e.stopPropagation()}>
        <div className="gallery-header">
          <button onClick={onBack} className="back-button">← 戻る</button>
          <h2>八戸市内のご飯屋</h2>
          <button onClick={onClose} className="close-button-x">✕</button>
        </div>
        
        <div className="restaurant-gallery">
          {restaurants.map((restaurant) => (
            <div key={restaurant.id} className="restaurant-card">
              <div className="restaurant-image">
                <img src={restaurant.image} alt={restaurant.name} />
              </div>
              <div className="restaurant-info">
                <h3>{restaurant.name}</h3>
                <p>{restaurant.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RestaurantGalleryModal;
